export const SAVE_ALL_ITINERARIES = 'SAVE_ALL_ITINERARIES'